<!-- sortReverse false is ascending order, true is descending: the arrow points the way the rows
  are ordered, so it must not be read as "click to sort the other way" (SB-16472). -->
<!-- The tooltip sits on the header itself, not on the "?" marker, so it opens on keyboard focus as
  well as on hover: the marker is not focusable and a nested focus target inside a role="button"
  would be read out twice (SB-16568). A header with a tooltip is focusable even when it does not sort. -->
<span [attr.role]="sortType ? 'button' : null"
  [attr.tabindex]="sortType || toolTip ? 0 : null"
  [ngbTooltip]="toolTip ? (toolTip | translate) : null"
  (click)="click()"
  (keydown.enter)="onActivateKey($event)"
  (keydown.space)="onActivateKey($event)"
  class="column-header">
  @if (labelIconName) {
    <sb-icon name="{{labelIconName}}"></sb-icon>
  }
  <span [innerHTML]="label | translate"></span>
  @if (toolTip) {
    <sup aria-hidden="true">?</sup>
    }&nbsp;
    @if (sortType && sortType != fieldName) {
      <sb-icon name="unsorted"></sb-icon>
    }
    @if (sortType && sortType == fieldName && !sortReverse) {
      <sb-icon name="sortUp"></sb-icon>
    }
    @if (sortType && sortType == fieldName && sortReverse) {
      <sb-icon name="sortDown"></sb-icon>
    }
  </span>